import React, { createContext, useContext } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { t } from 'i18next';

import { getCrumbs } from './crumbs';
import styles from './styles';

// Holds `{ current: path => void }`. A form with an unsaved-changes confirm sets `current`
// while mounted so breadcrumb links ask before leaving, the same as its Volver button.
export const LeaveGuardContext = createContext({ current: null });

function Breadcrumbs({ location, resources }) {
  const guard = useContext(LeaveGuardContext);
  const recordLabel = (resource, id) => {
    // Project codes identify a project better than its long name.
    if (resource === 'projects') return undefined;
    const record = resources[resource]?.data?.[id];
    return record && (record.name || record.nameEs || record.username);
  };
  const crumbs = getCrumbs(location.pathname, { t, recordLabel });
  if (!crumbs.length) return null;

  const onClick = to => event => {
    if (guard.current) {
      event.preventDefault();
      guard.current(to);
    }
  };

  return (
    <nav aria-label="breadcrumb" style={styles.nav}>
      {crumbs.map((crumb, index) => (
        <span key={index}>
          {index > 0 && <span style={styles.separator}>›</span>}
          {crumb.to ? (
            <Link to={crumb.to} onClick={onClick(crumb.to)} style={styles.link}>
              {crumb.label}
            </Link>
          ) : (
            <span style={styles.current}>{crumb.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export default withRouter(connect(state => ({ resources: state.admin.resources }))(Breadcrumbs));
